<div [attr.data-test-id]="'rapidReviewTest' + test.workflowTestId">
	<h4 class="panel-title mrgn-btm"><strong>{{ test.name }}</strong></h4>
	@for (field of test.formattedFields; track field) {
		<div [attr.data-test-id]="'rapidReviewField' + field.fieldValueId">
			<strong>
				@if (field.name) {
					@if (field.subName) {
						{{ field.name }} -
					} @else {
						{{ field.name }}:
					}
				} @if (field.subName) {
					<span [class]="field.subNameClass">{{ field.subName }}</span>:
				}
			</strong>
			<span [class]="field.valueClass"> {{ field.value }} </span>
			@if (field.additionalName) {
				<strong><span [class]="field.additionalNameClass">{{ field.additionalName }}</span>:</strong>
				<span [class]="field.additionalValueClass"> {{ field.additionalValue }} </span>
			}
		</div>
	}
</div>
